import React from 'react';
import { Container, Row, Col, Card, CardImg, CardBody } from 'reactstrap';

const PreviewSection: React.FC = () => {
  return (
    <section className="preview-section py-5" id="previews">
      <Container>
        <h2 className="text-center mb-5 fw-bold fs-2">Explore Our SaaS Platform Features</h2>
        <Row>
          <Col md={4}>
            <Card className="preview-card">
              <CardImg
                top
                src="https://placehold.co/400x300/ffffff/1e40af?text=Tenant+Management&font=Inter"
                alt="Tenant management dashboard preview"
              />
              <CardBody>
                <h5 className="fw-bold">Tenant Management</h5>
                <p>
                  Effortlessly manage multiple tenants with isolated data and custom configurations.
                </p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="preview-card">
              <CardImg
                top
                src="https://placehold.co/400x300/ffffff/1e40af?text=Subscription+Dashboard&font=Inter"
                alt="Subscription dashboard preview"
              />
              <CardBody>
                <h5 className="fw-bold">Subscription Dashboard</h5>
                <p>Monitor and manage subscriptions with real-time billing insights.</p>
              </CardBody>
            </Card>
          </Col>
          <Col md={4}>
            <Card className="preview-card">
              <CardImg
                top
                src="https://placehold.co/400x300/ffffff/1e40af?text=Support+Tickets&font=Inter"
                alt="Support tickets dashboard preview"
              />
              <CardBody>
                <h5 className="fw-bold">Support Tickets</h5>
                <p>Streamline customer support with an integrated ticketing system.</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default PreviewSection;
